import router from '../router/router';
import ConfigService from './config_service.js'
import LoginService from './login_service';


const configService = new ConfigService();
const config = configService.getConfig();
const loginService = new LoginService();

let routeListView = "";
let routeService = {
    goToHome: () => {
		if(loginService.esFacturacion()) {
			routeService.goTo("facturacion");
			return;
		}
        router.replace("/");
		
    },
    goToLogin: () => {
        router.replace("/login");
    },
    goTo(pathTo, params=null, byName= false) {
		let currentView = router.currentRoute.name;
		if(currentView.indexOf("s") == (currentView.length -1)) {
			routeListView = currentView;
		}
		let pushConfig = { path: '/' + pathTo, params: params }
		if(byName) {
			pushConfig = { name: pathTo, params: params }
		}
        router.push(pushConfig);
    },
	goToP(pathTo, params=null) {
        router.push({ name: pathTo, params: params });
    },
    goToBack() {
        window.history.length > 1 ? router.go(-1) : router.push('/')
    },
    getParams() {
        return router.history.current.params;
    },
    getRouter() {
        return router;
    },
	getListView() {
        return routeListView;
    },
	getActualPath() {
		return router.history.current.path;
	},
	destacarMenuItem(menuItem) {
		setTimeout(() => {
			document.querySelector('[href="/'+menuItem+'"]').className += " router-link-active";
		}, 500);
	},
	getPublicPath() {
		return config.baseResources;
	}
    
}

 export default routeService